(function () {
  function activeLocations(root) {
    return Array.from(root.querySelectorAll('[data-events-filter-location][aria-pressed="true"]')).map(function (btn) {
      return btn.getAttribute('data-events-filter-location');
    });
  }

  function selectedVendors(root) {
    return Array.from(root.querySelectorAll('.tavern-drops-filter-vendor:checked')).map(function (c) {
      return c.value;
    });
  }

  function syncBrandChip(root) {
    var el = root.querySelector('[data-tavern-brand-chip-value]');
    if (!el) return;
    var emptyLabel = el.getAttribute('data-empty-label') || '';
    var checked = Array.from(root.querySelectorAll('.tavern-drops-filter-vendor:checked'));
    if (checked.length === 0) {
      el.textContent = emptyLabel;
      return;
    }
    if (checked.length === 1) {
      el.textContent = checked[0].value;
      return;
    }
    var names = checked.map(function (c) {
      return c.value;
    });
    el.textContent = names.slice(0, 2).join(', ') + (names.length > 2 ? ' +' + String(names.length - 2) : '');
  }

  function applyFilters(root) {
    var locations = activeLocations(root);
    var vendors = selectedVendors(root);
    var vendorFilterActive = root.querySelectorAll('.tavern-drops-filter-vendor').length > 0 && vendors.length > 0;
    var locationFilterActive = locations.length > 0;
    var listings = document.querySelector('[data-page-events-listings]');
    var selectLocationPrompt = listings && listings.querySelector('[data-events-select-location-prompt]');
    var eventsList = listings && listings.querySelector('[data-events-list]');

    if (!locationFilterActive) {
      document.querySelectorAll('[data-events-card]').forEach(function (card) {
        card.hidden = true;
      });
      if (selectLocationPrompt) selectLocationPrompt.hidden = false;
      if (eventsList) eventsList.hidden = true;
      syncBrandChip(root);
    } else {
      if (selectLocationPrompt) selectLocationPrompt.hidden = true;
      if (eventsList) eventsList.hidden = false;

      document.querySelectorAll('[data-events-card]').forEach(function (card) {
        var show = true;
        var cardLocation = card.dataset.eventLocation || '';
        if (cardLocation !== '' && locations.indexOf(cardLocation) === -1) {
          show = false;
        }
        if (vendorFilterActive && vendors.indexOf(card.dataset.eventVendor || '') === -1) {
          show = false;
        }
        card.hidden = !show;
      });

      syncBrandChip(root);
    }

    if (typeof window.updatePageEventsShowMore === 'function' && listings) {
      window.updatePageEventsShowMore(listings);
    }
  }

  function bindFilters(root) {
    if (root.dataset.pageEventsFiltersBound === 'true') return;
    root.dataset.pageEventsFiltersBound = 'true';

    var reset = root.querySelector('[data-tavern-filter-reset]');

    root.addEventListener('click', function (event) {
      var locationBtn = event.target.closest('[data-events-filter-location]');
      if (locationBtn) {
        var pressed = locationBtn.getAttribute('aria-pressed') === 'true';
        locationBtn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        applyFilters(root);
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('.tavern-drops-filter-vendor')) {
        applyFilters(root);
      }
    });

    if (reset) {
      reset.addEventListener('click', function () {
        root.querySelectorAll('.tavern-drops-filter-vendor').forEach(function (cb) {
          cb.checked = false;
        });
        applyFilters(root);
      });
    }

    applyFilters(root);
  }

  function init() {
    document.querySelectorAll('[data-page-events-filters]').forEach(bindFilters);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.applyPageEventsFilters = function () {
    document.querySelectorAll('[data-page-events-filters]').forEach(applyFilters);
  };
})();
